import React, { useContext } from 'react'
import { FaShoppingBag } from 'react-icons/fa'
import { FaLocationDot } from 'react-icons/fa6'
import { TfiMedallAlt } from "react-icons/tfi";
import { BiMedal } from "react-icons/bi";
import { RiMedal2Line, RiVerifiedBadgeLine } from "react-icons/ri";
import { TbCalendarTime } from "react-icons/tb";

const PartnerCards = ({ company_name, profile_image, city, pricing_category, sector, user_id }) => {



  return (
    <div key={user_id}>
      <div className="d-flex align-items-center my-2">
        <div className="flex-shrink-0">
          <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${profile_image}`} alt="..." width={52} height={52} className='rounded-circle pe-none' />
        </div>
        <div className="flex-grow-1 ms-3">
          <h6 className='job-card-component-heading text-break pt-3'>{company_name}</h6>

          <label className="fs-7 card-inner-details col-12 pb-1">
            <FaLocationDot className="me-2 text-success" />
            {city}
          </label>

          <label className="fs-7 card-inner-details col-12 pb-1">
            <FaShoppingBag className="me-2 text-warning" />
            {sector}
          </label>
        </div>
      </div>

      <div className='flex-shrink-0 appliedOrSaved'>
        <div
          className={`py-1 px-3 appliedOrSaved-borderRadius
                  ${pricing_category === "unpaid" ? 'basic-plan' : null ||
              pricing_category === "trialing" ? 'basic-plan' : null ||
                pricing_category === "Basic" ? 'basic-plan' : null ||
                  pricing_category === "Premium" ? 'premium-plan' : null ||
                    pricing_category === "Platinum" ? 'platinum-plan' : null ||
                      pricing_category === "cancelled" ? 'platinum-plan' : null ||
                        pricing_category === "incomplete" ? 'platinum-plan' : null ||
                          pricing_category === "complete" ? 'platinum-plan' : null ||
                            pricing_category === "canceled" ? 'platinum-plan' : null
            }`
          }>

          <div className='m-0 px-2'>{pricing_category === "unpaid" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
            pricing_category === "trialing" ? <span><RiVerifiedBadgeLine className='fs-5' /> Free trial</span> : null ||
              pricing_category === "Basic" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
                pricing_category === "complete" ? <span><TfiMedallAlt className='fs-5' /> Basic</span> : null ||
                  pricing_category === "Premium" ? <span><BiMedal className='fs-5' /> Premium</span> : null ||
                    pricing_category === "Platinum" ? <span><RiMedal2Line className='fs-5' /> Platinum</span> : null ||
                      pricing_category === "cancelled" ? <span><TbCalendarTime className='fs-5' /> Plan Canceled</span> : null ||
                        pricing_category === "canceled" ? <span><TbCalendarTime className='fs-5' /> Plan Canceled</span> : null ||
                          pricing_category === "incomplete" ? <span><TbCalendarTime className='fs-5' /> Expired</span> : null
          }</div>
        </div>
      </div>
    </div>
  )
}

export default PartnerCards